// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Check20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Check20Circle: FC<Check20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM6.549 12.52l3.68 3.702L17.451 9l-1.206-1.227-6.016 5.995-2.474-2.453-1.206 1.206Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Check20Circle;
